import registerLegalPartner from "./registerLegalPartner";

export { registerLegalPartner };
